import React from 'react'

export const ButtonOffBlack: React.FunctionComponent<{onClick?: ()=>void, className?: string, children: any}> = ({onClick, className, children}) => {
  return (
    <div role="button" onClick={onClick} className={`bg-off-black btn text-white ${className ? className : ''}`}>{children}</div>
  )
}
